import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col } from "reactstrap";
import classNames from "classnames";
import { getCacheImage } from "../../config";
import fireIcon from "../../images/fire-product.png"

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classNameBanner } = this.props;

    return (
      <Row className={classNames("wrapper__banner", classNameBanner)}>
        <Col md={12}>
          <KickImage noCompress src={getCacheImage(this.props.src)} alt={this.props.src} style={this.props.style} />
        </Col>
      </Row>
    );
  }
}

export default Banner;
